import { render, staticRenderFns } from "./enquiry-detail.vue?vue&type=template&id=2acd5698&scoped=true&"
import script from "./enquiry-detail.vue?vue&type=script&lang=js&"
export * from "./enquiry-detail.vue?vue&type=script&lang=js&"
import style0 from "./enquiry-detail.vue?vue&type=style&index=0&id=2acd5698&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acd5698",
  null
  
)

export default component.exports